import { axiosRawClient, getRequest, postRequest } from '@bo-apis/axios';

const info = () =>
  getRequest({
    url: 'api/v1/auth/info',
  });

const ssoLogin = (payload) =>
  postRequest(
    {
      url: 'api/v1/auth/login',
      data: payload,
    },
    { skipError: true, skipSpinner: true }
  );

const reissue = (token) =>
  axiosRawClient({
    method: 'POST',
    url: 'api/v1/auth/reissue',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const logout = () =>
  postRequest({
    method: 'POST',
    url: 'api/v1/auth/logout',
  });

const getDecrypt = (payload) =>
  postRequest({
    url: 'api/v1/common/auth/decrypt',
    data: payload,
  });

const authApi = {
  info,
  ssoLogin,
  reissue,
  logout,
  getDecrypt,
};

export default authApi;
